import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import AuthService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("user"));

export const register = createAsyncThunk("auth/register", async ({ name, email, password, passwordConfirm, company }, thunkAPI) => {
    try {
        const response = await AuthService.register(name, email, password, passwordConfirm, company);
        thunkAPI.dispatch(setMessage(response.data.message));
        return response.data;
    } catch (error) {
        let message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const login = createAsyncThunk("auth/login", async ({ email, password }, thunkAPI) => {
    try {
        const data = await AuthService.login(email, password);
        return { user: data };
    } catch (error) {
        let message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        if (error?.response?.status === 401 || error?.response?.status === 403)
        {
            message = "Incorrect Username or Password"
        }
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const ssoAuth = createAsyncThunk("auth/ssoauth", async ({ token }, thunkAPI) => {
    try {
        const data = await AuthService.ssoLogin(token);
        return { user: data };
    } catch (error) {
        console.log("Error: ", error);
        const message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const cnAuth = createAsyncThunk("auth/cnauth", async ({ token }, thunkAPI) => {
    try {
        const data = await AuthService.cnLogin(token);
        return { user: data };
    } catch (error) {
        console.log("Error: ", error);
        const message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const googleSsoAuth = createAsyncThunk("auth/google-sso", async ({ token }, thunkAPI) => {
    try {
        const data = await AuthService.GoogleSsoLogin(token);
        return { user: data };
    } catch (error) {
        console.log("Error: ", error);
        const message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const oktaSsoAuth = createAsyncThunk("auth/okta-sso", async ({ token }, thunkAPI) => {
    try {
        const data = await AuthService.OktaSsoLogin(token);
        return { user: data };
    } catch (error) {
        console.log("Error: ", error);
        const message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const oktaGetClientID = createAsyncThunk("auth/okta-get-client", async ({ iss }, thunkAPI) => {
    try {
        const data = await AuthService.oktaGetClientID(iss);
        console.log('oktaGetClientID data:', data);
        return data;
    } catch (error) {
        console.log("Error: ", error);
        const message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const logout = createAsyncThunk("auth/logout", async () => {
    AuthService.logout();
    return { message: 'Logout successful' };
});


export const forgot = createAsyncThunk("auth/login", async ({ email, siteUrl }, thunkAPI) => {
    try {
        const data = await AuthService.forgot(email, siteUrl);
        return { user: data };
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.detail) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const resetPassword = createAsyncThunk("auth/resetPassword", async ({ email, token, newPassword }, thunkAPI) => {
        try {
            const response = await AuthService.resetPassword(email, token, newPassword);
            thunkAPI.dispatch(setMessage("Password reset successfully"));
            return response.data;
        } catch (error) {
            console.error('Error in resetPassword thunk:', error);
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const mfaSetup = createAsyncThunk("auth/mfa-setup", async (_, thunkAPI) => {
    try {
        const data = await AuthService.mfaSetup();
        return data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const mfaVerify = createAsyncThunk("auth/mfa-verify", async ({ code }, thunkAPI) => {
    try {
        const data = await AuthService.mfaVerify(code);
        thunkAPI.dispatch(setMessage("MFA enabled successfully!"));
        return data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const loginWithMfa = createAsyncThunk("auth/login-mfa", async ({ email, password, code }, thunkAPI) => {
    try {
        const data = await AuthService.loginWithMfa(email, password, code);
        return { user: data };
    } catch (error) {
        let message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        if (error?.response?.status === 401 || error?.response?.status === 403) {
            message = "Incorrect credentials or MFA code";
        }
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const token = createAsyncThunk("auth/logout", async () => {
});

const initialState = user
    ? {
        isLoggedIn: true,
        user,
        requiresMfaSetup: user.requiresMfaSetup || false
    }
    : {
        isLoggedIn: false,
        user: null,
        requiresMfaSetup: false
    };

const authSlice = createSlice({
    name: "auth",
    initialState,
    extraReducers: {
        [register.fulfilled]: (state) => {
            state.isLoggedIn = false;
        },
        [register.rejected]: (state) => {
            state.isLoggedIn = false;
        },
        [login.fulfilled]: (state, action) => {
            state.isLoggedIn = true;
            state.user = action.payload.user;
            state.requiresMfaSetup = action.payload.user.requiresMfaSetup || false;
        },
        [login.rejected]: (state) => {
            state.isLoggedIn = false;
            state.user = null;
            state.requiresMfaSetup = false;
        },
        [mfaVerify.fulfilled]: (state, action) => {
            state.requiresMfaSetup = false;
            const user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                user.requiresMfaSetup = false;
                localStorage.setItem('user', JSON.stringify(user));
            }
        },
        [ssoAuth.fulfilled]: (state, action) => {
            state.isLoggedIn = true;
            state.user = action.payload.user;
        },
        [ssoAuth.rejected]: (state) => {
            state.isLoggedIn = false;
            state.user = null;
        },
        [googleSsoAuth.fulfilled]: (state, action) => {
            state.isLoggedIn = true;
            state.user = action.payload.user;
        },
        [googleSsoAuth.rejected]: (state) => {
            state.isLoggedIn = false;
            state.user = null;
        },
        [loginWithMfa.fulfilled]: (state, action) => {
            state.isLoggedIn = true;
            state.user = action.payload.user;
            state.requiresMfaSetup = false;
        },
        [loginWithMfa.rejected]: (state) => {
            state.isLoggedIn = false;
            state.user = null;
            state.requiresMfaSetup = false;
        },
        [logout.fulfilled]: (state) => {
            state.isLoggedIn = false;
            state.user = null;
        },
        [logout.fulfilled]: (state) => {
            state.isLoggedIn = false;
            state.user = null;
        },
        [token.fulfilled]: (state, action) => {
            state.token = action.payload.token;
            state.isLoggedIn = true;
        }
    }
});

const { reducer } = authSlice;
export default reducer;